import React from "react";
import whyModliBanner from '../../../../assets/images/whyModliBanner.jpg'

const WhyModli3DSection: React.FC = () => {
    return (
        <section
            className="elementor-section elementor-top-section elementor-element elementor-section-height-default sc_fly_static"
            style={{
                padding: '60px 0',
                backgroundColor: '#ffffff',
                overflow: 'hidden'
            }}
        >
            <div className="elementor-container elementor-column-gap-extended">
                <div className="elementor-row" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                    <div
                        className="elementor-column elementor-col-50 animated fadeInLeft"
                        style={{ padding: '20px' }}
                    >
                        <div
                            className="image-wrapper"
                            style={{
                                position: 'relative',
                                borderRadius: '24px',
                                overflow: 'hidden',
                                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                                transform: 'perspective(1000px) rotateY(5deg)'
                            }}
                        >
                            <img
                                src={whyModliBanner}
                                alt="3D Printing Craftsmanship"
                                style={{
                                    width: '100%',
                                    display: 'block',
                                    transition: 'transform 0.5s ease'
                                }}
                            />
                            {/* <div
                                style={{
                                    position: 'absolute',
                                    bottom: '30px',
                                    left: '30px',
                                    backgroundColor: 'rgba(238, 85, 54, 0.9)',
                                    color: '#fff',
                                    padding: '12px 24px',
                                    borderRadius: '50px',
                                    fontFamily: '"Red Hat Display", sans-serif',
                                    fontSize: '14px',
                                    fontWeight: '700',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.1em'
                                }}
                            >
                                Precision Focused
                            </div> */}
                        </div>
                    </div>
                    <div
                        className="elementor-column elementor-col-50 animated fadeInRight"
                        style={{ padding: '20px 60px' }}
                    >
                        <div className="sc_title sc_title_default">
                            <span
                                className="sc_item_subtitle sc_title_subtitle sc_item_subtitle_above sc_item_title_style_default"
                            >
                                Why Modli 3D
                            </span>
                            <h2
                                className="sc_item_title sc_title_title"
                                style={{
                                    fontWeight: '800',
                                    lineHeight: '1.3',
                                    color: '#1B1E25',
                                    marginBottom: '35px'
                                }}
                            >
                                It's Not just a transaction, <br />
                                <span style={{ color: '#EE5536' }}>it’s a partnership.</span>
                            </h2>
                            <div
                                className="sc_item_descr sc_title_descr"
                                style={{
                                    lineHeight: '1.8',
                                    color: '#555A64'
                                }}
                            >
                                <p style={{ marginBottom: '25px' }}>
                                    Unlike automated print marketplaces, we don’t treat projects as transactions.
                                    Every design is reviewed, optimized, and carefully produced with attention
                                    to both form and function.
                                </p>
                                <p style={{ fontWeight: '600', color: '#1B1E25' }}>
                                    This hands-on approach allows us to deliver results that are not only
                                    visually appealing, but practical, reliable, and production-ready.
                                </p>
                            </div>
{/* 
                            <div className="ornament" style={{ marginTop: '40px' }}>
                                <svg width="100" height="8" viewBox="0 0 100 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 4H100" stroke="#EE5536" strokeWidth="2" strokeDasharray="10 10" />
                                </svg>
                            </div> */}
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default WhyModli3DSection;
